import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Usage`}</h2>
    <p>{`Radius is the blunt part of the corner of a component that affects the shape and visibility of the content inside. This is the variant of radius we use globally for property the component. You can chek out the guideline for more detail description.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`<Content>.radius<no>()
`}</code></pre>
    <div className="divi" />
    <h2>{`Preview`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Shape`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Token Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius2" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.radius2()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius4" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.radius4()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius6" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.radius6()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius8" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.radius8()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius12" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.radius12()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius16" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.radius16()`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div className="radius24" /></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.radius24()`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`<Content>.radius2()
<Content>.radius4()
<Content>.radius6()
<Content>.radius8()
<Content>.radius12()
<Content>.radius16()
<Content>.radius24()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      